import { render, staticRenderFns } from "./SaveLaboratorioCartera.vue?vue&type=template&id=6111ee5f"
import script from "./SaveLaboratorioCartera.vue?vue&type=script&lang=js"
export * from "./SaveLaboratorioCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports